// @ts-check

import { useSharedStore } from '@/store/shared'
import { v4 as uuidv4 } from 'uuid'
import { computed, markRaw, ref } from 'vue'

/**
 * @typedef {Object} Dialog
 * @property {import('vue').Component} component - The dialog component being shown.
 * @property {{ [prop: string]: unknown}} [props = undefined] - The properties to pass to the dialog component.
 * @property {{ [prop: string]: Function|undefined}} [listeners = undefined] - The listeners to pass to the dialog component
 */

/**
 * @typedef {Dialog & { id: string }} DialogWithId
 */

/** @type {import('vue').Ref<?DialogWithId>} */
const managedDialog = ref(null)

/**
 * Shows the given dialog.
 * @param {Dialog} dialog
 * @returns {DialogWithId}
 */
const showDialog = (dialog) => {
  const shownDialog = {
    ...dialog,
    id: uuidv4(),
    component: markRaw(dialog.component)
  }
  useSharedStore().isDialogOpen = true
  managedDialog.value = shownDialog
  return shownDialog
}

/**
 * Close the managed dialog.
 */
const closeDialog = () => {
  useSharedStore().isDialogOpen = false
  managedDialog.value = null
}

export const useDialog = () => {
  const dialog = computed(() => managedDialog.value)

  return {
    dialog,
    showDialog,
    closeDialog
  }
}

export default useDialog
